import { reportErrorMessage } from "#/utils/ErrorReporting"

// @ts-expect-error TS(7006) FIXME: Parameter 'source' implicitly has an 'any' type.
export function validateContentSource(source, overrides) {
  const customMarkdownTags = Object.keys(overrides).filter(
    (markdownKey) => markdownKey.charAt(0) === markdownKey.charAt(0).toUpperCase()
  )
  return contentValidator(source, customMarkdownTags)
}

function contentValidator(source: string, customMarkdownTags: string[]) {
  if (!source) {
    return null
  }

  const invalidOpeningTags = customMarkdownTags.reduce((accum, markdownTag) => {
    const openingCarat = "<"
    const downCasedMarkdownTag = markdownTag.charAt(0).toLowerCase() + markdownTag.slice(1)
    return { ...accum, [openingCarat + downCasedMarkdownTag]: openingCarat + markdownTag }
  }, {})

  let validatedSource = source

  Object.keys(invalidOpeningTags).forEach((invalidTag) => {
    if (validatedSource.includes(invalidTag)) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      validatedSource = validatedSource.replace(invalidTag, invalidOpeningTags[invalidTag])
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      reportErrorMessage(`Replaced an invalid markdown tag "${invalidTag}" with "${invalidOpeningTags[invalidTag]}`)
    } else {
      return null
    }
  })
  return validatedSource
}
